import { Module } from 'vuex';
import { HistoryState } from '@/features/shipment-history/types';
import mutations from './mutations';
import getters from './getters';

// eslint-disable-next-line @typescript-eslint/no-explicit-any
const pickup: Module<HistoryState, any> = {
  state: {
    historyItems: [],
  },
  mutations,
  getters,
};

export default pickup;
